import { App } from 'antd';
import { useCallback } from 'react';

import {
  openGuardedFormModal,
  type GuardedFormModalInstance,
  type OpenGuardedFormModalOptions,
} from '../../utils/openGuardedFormModal';
import { wrapGuardedFormModalContent } from '../../utils/wrapGuardedFormModalContent';
import { useRequestLeave } from '../useRequestLeave';

type OpenGuardedFormModalParams = Omit<OpenGuardedFormModalOptions, 'modal' | 'requestLeave'>;

/** Returns a helper to open form modals with unsaved-changes protection. */
export function useOpenGuardedFormModal(): (
  options: OpenGuardedFormModalParams,
) => GuardedFormModalInstance {
  const { modal } = App.useApp();
  const requestLeave = useRequestLeave();

  return useCallback(
    (options: OpenGuardedFormModalParams) =>
      openGuardedFormModal({
        ...options,
        content: wrapGuardedFormModalContent(options.content),
        modal,
        requestLeave,
      }),
    [modal, requestLeave],
  );
}
